/** @format */

import React, { useState } from "react";
import "./main.css";
import Sidebar from "./sideBar";
import About from "../components/about";
import Resume from "../components/resume";
import Portfolio from "../components/portfolio";
import Contact from "../components/contact";

const MainScreen = () => {
  const [activeLink, setActiveLink] = useState("about");

  const handleNavigation = (link) => {
    setActiveLink(link);
    window.scrollTo(0, 0);
  };

  const renderContent = () => {
    switch (activeLink) {
      case "about":
        return <About />;
      case "resume":
        return <Resume />;
      case "portfolio":
        return <Portfolio />;

      case "contact":
        return <Contact />;
      default:
        return <About />;
    }
  };

  return (
    <main>
      <Sidebar />
      <div className="main-content">
        <nav className="navbar">
          <ul className="navbar-list">
            <li className="navbar-item">
              <button
                className={`navbar-link ${
                  activeLink === "about" ? "active" : ""
                }`}
                onClick={() => handleNavigation("about")}
              >
                About
              </button>
            </li>
            <li className="navbar-item">
              <button
                className={`navbar-link ${
                  activeLink === "resume" ? "active" : ""
                }`}
                onClick={() => handleNavigation("resume")}
              >
                Resume
              </button>
            </li>
            <li className="navbar-item">
              <button
                className={`navbar-link ${
                  activeLink === "portfolio" ? "active" : ""
                }`}
                onClick={() => handleNavigation("portfolio")}
              >
                Portfolio
              </button>
            </li>

            <li className="navbar-item">
              <button
                className={`navbar-link ${
                  activeLink === "contact" ? "active" : ""
                }`}
                onClick={() => handleNavigation("contact")}
              >
                Contact
              </button>
            </li>
          </ul>
        </nav>
        {renderContent()}
      </div>
    </main>
  );
};

export default MainScreen;
